import { handleGetRequest, handlePostRequest ,handlePatchRequest} from "../hooks/api";

export async function getBusinessDetailByPlaceId(placeId) {
  const googleApiKey = process.env.REACT_APP_GOOGLEMAP_API;
  const payload = {
    placeId: placeId,
    apiKey: googleApiKey
  };
  const response = await handlePostRequest(
    "/location/retrieveGooglePlaceDetails",
    payload,
    undefined,
    false
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

export async function getBusinessTypesAndServices() {
  const response = await handleGetRequest(
    "/business/getBusinessTypesAndServices",
    {}
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

export async function addBusiness(payload) {
  const response = await handlePostRequest(
    "/business/addBusiness",
    payload,
    undefined
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

export async function reportBusiness(payload) {
  const response = await handlePostRequest(
    "/business/report-business",
    payload,
    undefined
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

export async function claimBusiness(payload) {
  const response = await handlePostRequest(
    "/business/claim-business",
    payload,
    undefined
  );
  if (response?.error) {
    throw new Error(response.error);
  }
  return response;
}

export async function addBusinessDiscount(payload) {
  const response = await handlePostRequest(
    "/business/addDiscount",  
    payload,
    undefined
  );

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}


export async function createBusinessCatalog(payload) {
  const response = await handlePostRequest(
    "/business/createCatalog",  
    payload,
    undefined
  );

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function addBusinessInfo(payload) {
  const response = await handlePostRequest(
    "/business/additional-info",  
    payload,
    undefined
  );

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function editBusinessDetailsInfo(payload) {
  const response = await handlePostRequest(
    "/business/editBusinessDetails-info",  
    payload,
    undefined
  );

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

export async function editBusinessDetails(payload) {
  const response = await handlePatchRequest(
    "/business/editBusinessDetails",  
    payload,
    undefined
  );

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}

// Fetch catalog for a specific business
export async function getBusinessCatalog(businessId) {
  if (!businessId) {
    throw new Error("Business ID is required");
  }

  const response = await handleGetRequest(`/business/getCatalog/${businessId}`, {});

  if (response?.error) {
    throw new Error(response.error);
  }

  return response;
}
